// extracted by mini-css-extract-plugin
module.exports = {"item":"SearchItem_item__eQZAY","itemContent":"SearchItem_itemContent__h6vxl","prefix":"SearchItem_prefix__SOnRa"};